import {immediate} from 'disposable-frames'
import throttle from 'lodash.throttle'

const DEFAULT_INIT = () => []
const RETURNS_TRUE = () => true
const NOOP = () => {}

// Action scheduler
export const schedule = (
  action,
  {
    // The number of milliseconds to throttle invocations to.
    wait = 0,
    // dispose the invocation if the delay exceeds `tolerance`.
    // 0 to disable the feature
    tolerance = 0,
    // max wait for no invocation util forcing execution. 0 to disable the feature
    maxWait = 0,
    // true to always force the first invocation
    leading = false,
    // method to create the initial payload collection
    init = DEFAULT_INIT,
    // method to collect the payload into the collection
    collect,
    // to test the collection to determine whether we should dispatch
    test = RETURNS_TRUE
  } = {}
) => {
  let host
  // let resolve;
  // let currentDispatch

  const reset = () => {
    host = init()
  }

  reset()

  const disposable = immediate(
    () => {
      if (!test(host)) {
        return
      }

      let data = host
      reset()
      action(data)
      data = null
    },
    {
      tolerance,
      maxWait,
      leading
    }
  )

  const wrapped = wait === 0 ? disposable : throttle(disposable, wait)

  return datum => {
    collect(datum, host)
    wrapped()
    // return dispatch => {
    //   currentDispatch = dispatch
    // }
  }
}

export const simple = (
  action,
  {
    wait = 0, init = DEFAULT_INIT, collect, test = RETURNS_TRUE
  } = {}
) => {
  let host
  const reset = () => {
    host = init()
  }
  let last

  reset()

  return datum => {
    collect(datum, host)
    return dispatch => {
      const now = Date.now()
      if ((!last || now - last > wait) && test(host)) {
        last = now
        action(host, dispatch)
        host = null
        reset()
      }
    }
  }
}

export class TrafficHolder {
  constructor (consume, {onPause = NOOP, onResume = NOOP} = {}) {
    this._consume = consume
    this._onPause = onPause
    this._onResume = onResume
    this._stack = []
    this._paused = false
    this.receive = consume
  }

  _push (datum) {
    this._stack.push(datum)
  }

  pause () {
    this._paused = true
    this.receive = this._push
    this._onPause()
    return this
  }

  isPaused () {
    return this._paused
  }

  resume () {
    this._paused = false
    this._onResume()
    const consume = this._consume
    this._stack.forEach(consume)
    this._stack.length = 0
    this.receive = consume
    return this
  }
}
